import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import LegalProductCard from "./LegalProductCard";
import { listBots } from "../actions/botActions";
import DashHeader from "./DashHeader";
import ProdCardLoader from "./Preloader-Card";
import ComponentSearch from "./ComponentSearch";
import { Helmet } from "react-helmet-async";
import { useSearchParams, useNavigate } from "react-router-dom";

function LegalProducts({ userInfo }) {
  // http://localhost:3000/dashboard/legal-products?cat=Website%2C+Digital%2C+and+Data&tag=Running+my+Business

  let [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line
  const navigate = useNavigate(); // eslint-disable-line
  const dispatch = useDispatch();
  const botList = useSelector((state) => state.botList);
  const { bots } = botList;

  // const userLogin = useSelector((state) => state.userLogin);
  // const { error, userInfo } = userLogin;
  console.log("userinfo", userInfo);
  // if (userInfo.role === "sme") {
  //   const sme = useSelector((state) => state.userSMEDetails);
  // }

  // get user profile type
  const tokenCount = useSelector((state) => {
    if (userInfo?.role === "sme") {
      const { sme } = state.userSMEDetails;
      return sme.tokenCount;
    }
    return null;
  });

  console.log("token count", tokenCount);

  let categories = new Set();

  let tags = new Set(); //Set a new tag array -RC
  // bots.forEach((item) => categories.add(item.category));
  let types = new Set();

  // while querying: ghost load
  // after query: bots
  // filter with no results: "no resutls"
  for (var key in bots) {
    var bot = bots[key];
    for (var key2 in bot.categories) {
      categories.add(bot.categories[key2]);
    }
    for (var key3 in bot.tags) {
      //Added loop for Tags
      tags.add(bot.tags[key3]);
    }
    //for (var key4 in bot.type){ Bot cannot currently have more than one type
    types.add(bot.type);
    // console.log(types);
    //}
  }

  let categoriesList = [...categories.values()];

  let tagList = [...tags.values()];

  let typeList = [...types.values()];

  //Building list for tag

  const [stateBots, setStateBots] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedTag, setSelectedTag] = useState(); //Tag Selected State
  const [selectedType, setSelectedType] = useState();
  /*  const [botsLeftToFilter, setBotsLeftToFilter] = useState(true); */
  const [queryingBots, setQueryingBots] = useState(true);

  function filterByCategory(category) {
    if (selectedTag || selectedType) {
      setStateBots((prev) =>
        !category
          ? bots
          : prev.filter((bot) => bot.categories.includes(category))
      );
    }
    setStateBots((prev) =>
      !category ? bots : bots.filter((bot) => bot.categories.includes(category))
    );
  }

  function filterByType(type) {
    if (selectedTag || selectedCategory) {
      setStateBots((prev) =>
        !type ? bots : prev.filter((bot) => bot.type.includes(type))
      );
    }
    setStateBots((prev) =>
      !type ? bots : bots.filter((bot) => bot.type.includes(type))
    );
  }

  //  else if(tag && !category){
  //       setStateBots((prev) =>
  //       !tag ? bots : bots.filter((bot) => bot.tags.includes(tag))
  //     );
  //  }
  //  // Add a piece of code to filter for both Tags and categories what is the first part
  //    if(category && tag){
  //    setStateBots((prev) =>
  //          bots.filter((bot) => bot.categories.includes(category)+bot.tags.includes(tag))
  //        );
  //    }
  //}

  //Filter function for Tag -RC
  function filterByTag(tag) {
    if (selectedCategory || selectedType) {
      setStateBots((prev) =>
        !tag ? bots : prev.filter((bot) => bot.tags.includes(tag))
      );
    } else {
      setStateBots((prev) =>
        !tag ? bots : bots.filter((bot) => bot.tags.includes(tag))
      );
    }
  }

  useEffect(() => {
    dispatch(listBots());
  }, [dispatch]);

  useEffect(() => {
    setStateBots(bots);
    setQueryingBots((queryingBots) => !queryingBots);
  }, [bots]);

  useEffect(() => {
    if (!queryingBots) {
      const cat = searchParams.get("cat");
      const tag = searchParams.get("tag");
      const type = searchParams.get("type");
      if (cat !== undefined && !tag && !type) {
        filterByCategory(cat);
        console.log("filter test : Cat ran");
        setSelectedCategory((prev) => cat);
      } else if (tag !== undefined && !cat && !type) {
        filterByTag(tag);
        console.log("filter test : tag ran");
        setSelectedTag((prev) => tag);
      } else if (type !== undefined && !tag && !cat) {
        filterByType(type);
        setSelectedType((prev) => type);
      } else if (tag !== undefined && cat !== undefined) {
        filterByCategory(cat);
        filterByTag(tag);
        console.log("filter test : Both ran");
        setSelectedCategory(cat);
        setSelectedTag(tag);
      }
      // if (type !== undefined) {
      //   filterByType(type);
      // } else if (tag !== undefined) {
      //   filterByTag(tag);
      // } else if (cat !== undefined) {
      //   filterByCategory(cat);
      // }
    }
  }, [queryingBots]); // eslint-disable-line

  useEffect(() => {
    filterByCategory(selectedCategory);
    // eslint-disable-next-line
  }, [selectedCategory]);

  //useEffect for Tags

  useEffect(() => {
    filterByTag(selectedTag);
    // eslint-disable-next-line
  }, [selectedTag]);

  //useEffect for Types

  useEffect(() => {
    filterByType(selectedType);
    // eslint-disable-next-line
  }, [selectedType]);

  // console.log("search cat", searchParams.get("cat"));
  // console.log("search tag", searchParams.get("tag"));
  // console.log("cat", param.category);
  // console.log("tag", param.tag);
  console.log("selected category", selectedCategory);
  console.log("selected tag", selectedTag);
  console.log("selected type", selectedType);
  console.log("stateBots", stateBots);

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
        <title>Lacoona Legal Products</title>
        <meta
          name="description"
          content="Our range of guided documents and legal flows on Lacoona Legal"
        />
        <link rel="canonical" href="/dashboard/legal-products" />
      </Helmet>
      <DashHeader pageTitle={"Legal Products"} />
      <Row className="dashboard-content-container">
        <Row className="dashboard-content-divider"></Row>
        <Row>
          <h2 className="ll-subtitle ll-feat-font">Legal Products</h2>
        </Row>
        <Row className="dashboard-content-divider"></Row>
        <Row className="ll-search-filter-parents">
          <Col align="center" lg={2}>
            <Dropdown className="mx-auto d-flex justify-content-center">
              <Dropdown.Toggle
                variant="dark"
                className="lcn-button-brown"
                id="dropdown"
              >
                {selectedCategory ? selectedCategory : "Filter by category"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  name="All"
                  onClick={(e) => setSelectedCategory(null)}
                >
                  All
                </Dropdown.Item>
                {categoriesList.map((item) => {
                  return (
                    <Dropdown.Item
                      key={item}
                      name={item}
                      onClick={(e) =>
                        setSelectedCategory((prev) => e.target.name)
                      }
                    >
                      {item}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col align="center" lg={2}>
            {" "}
            {/* For tags */}
            <Dropdown className="mx-auto d-flex justify-content-center">
              <Dropdown.Toggle
                variant="dark"
                className="lcn-button-brown"
                id="dropdown"
              >
                {selectedTag ? selectedTag : "Filter by Tag"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item name="All" onClick={(e) => setSelectedTag(null)}>
                  All
                </Dropdown.Item>
                {tagList.map((item) => {
                  return (
                    <Dropdown.Item
                      key={item}
                      name={item}
                      onClick={(e) => setSelectedTag((prev) => e.target.name)}
                    >
                      {item}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col align="center" lg={2}>
            {" "}
            {/* For Type */}
            <Dropdown className="mx-auto d-flex justify-content-center">
              <Dropdown.Toggle
                variant="dark"
                className="lcn-button-brown"
                id="dropdown"
              >
                {selectedType ? selectedType : "Filter by Type"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  name="All"
                  onClick={(e) => setSelectedType(null)}
                >
                  All
                </Dropdown.Item>
                {typeList.map((item) => {
                  return (
                    <Dropdown.Item
                      key={item}
                      name={item}
                      onClick={(e) => setSelectedType((prev) => e.target.name)}
                    >
                      {item === "document" && "Document"}
                      {item === "legalflow" && "Legal Flow"}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
            {/* Try and use icons   */}
          </Col>
          <Col lg={6}>
            <ComponentSearch
              list={bots}
              setBots={setStateBots}
              className="w-75 mx-auto mb-3 ll-prod-search"
            />
          </Col>
        </Row>
        <Row className="dashboard-content-divider"></Row>
        {stateBots.length > 0 &&
          stateBots.map((bot) => (
            <Col key={bot.id} lg={6} md={12} sm={12}>
              <LegalProductCard
                id={bot.id}
                title={bot.name}
                image={bot.image}
                category={bot.categories}
                description={bot.description}
                excerpt={bot.excerpt}
                tokenCount={tokenCount}
                userInfo={userInfo}
              />
            </Col>
          ))}
        {queryingBots && (
          <div className="px-3">
            <Row>
              <Col>
                <ProdCardLoader />
              </Col>
              <Col>
                <ProdCardLoader />
              </Col>
            </Row>
            <Row>
              <Col>
                <ProdCardLoader />
              </Col>
              <Col>
                <ProdCardLoader />
              </Col>
            </Row>
            <Row>
              <Col>
                <ProdCardLoader />
              </Col>
              <Col>
                <ProdCardLoader />
              </Col>
            </Row>
          </div>
        )}
      </Row>
    </Col>
  );
}

export default LegalProducts;
